import type { UpdateMeterRequestPayload, UpdateMeterResponse } from '@weft/api-definition';
import { UpdateMeterResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateMeter(options?: UseMutationOptions<UpdateMeterResponse, unknown, UpdateMeterRequestPayload & { id: string }>) {
  return useMutation({
    mutationFn: async ({ id, ...newMeter }) => {
      const api = getPrivateApi();

      const updateMeterResponse = await api.updateMeter({
        meterId: id,
        updateMeterRequest: newMeter,
      });

      return UpdateMeterResponseSchema.parse(updateMeterResponse);
    },
    ...options,
  });
}